import { createApp } from "vue";
import application from "./application.vue";
if (import.meta.env.MODE === "simple-keiri") {
  import("../../src/tailwind-simple-keiri.css");
} else {
  import("../../src/tailwind.css");
}

import router from "./router";

const app = createApp(application);

app.use(router);

app.mount("#app");
